import { useCurrentFile } from '@/hooks/useCurrentFile';
import { datasetSliceName } from '@/redux/constants';
import { openSpreadsheet } from '@/Utils/utils';
import clsx from 'clsx';
import { useSelector } from 'react-redux';
import Icon from '../UI/Icon/Icon';

const LinkedSheetTag = ({ isLinkedSheet }) => {
  const currentFile = useCurrentFile();

  const { libraryFiles } = useSelector((state) => state[datasetSliceName]);
  const { Details } = currentFile?.metadata || {};

  const isParentSheetOwnedByUser = () =>
    libraryFiles.find((file) => file?.metadata?.FileUuid === Details?.view?.parent);

  const findLinkedSheetParent = () => {
    if (!isParentSheetOwnedByUser) {
      return '';
    } else {
      return (
        libraryFiles.find((file) => file?.metadata?.FileUuid === Details?.view?.parent)?.metadata ||
        {}
      );
    }
  };

  const linkedSheetParent =
    isLinkedSheet && isParentSheetOwnedByUser ? findLinkedSheetParent()?.FileName : null;

  const openLinkedSheetParent = () => {
    if (!isParentSheetOwnedByUser) {
      return;
    } else {
      const { FileUuid, FileName } = findLinkedSheetParent();
      openSpreadsheet(FileUuid, FileName);
    }
  };

  return (
    <div
      role='button'
      tabIndex='0'
      onClick={openLinkedSheetParent}
      onKeyDown={openLinkedSheetParent}
      className={clsx(
        'hover:bg-opacity-100 bg-opacity-40 absolute cursor-pointer top-[38px] right-0 tracking-tight rounded-full bg-sunrise-200 border-sunrise-700 border flex text-sm px-2 py-1 h-6 items-center gap-1 text-sunrise-800 font-medium',
        !isLinkedSheet && 'hidden'
      )}
    >
      <Icon name='link' size={16} /> Linked{' '}
      {!isParentSheetOwnedByUser ? (
        'Sheet'
      ) : (
        <>
          to <span className='font-semibold truncate max-w-64'>{linkedSheetParent}</span>
        </>
      )}
    </div>
  );
};

export default LinkedSheetTag;
